import { render, staticRenderFns } from "./communications.page.vue?vue&type=template&id=e7139872&"
import script from "./communications.page.vue?vue&type=script&lang=ts&"
export * from "./communications.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports